import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Text } from '@/components/ui/text';
import { useDeleteSharedKnowledgeGroupService } from '@/services/sharedFiles';
import { Trash } from 'lucide-react';
import { useState, type FC } from 'react';

export const DeleteGroupModal: FC<{
  groupId: string;
}> = ({ groupId }) => {
  const { deleteGroup } = useDeleteSharedKnowledgeGroupService();
  const [isOpen, setIsOpen] = useState(false);

  const handleDelete = () => {
    deleteGroup({ id: groupId });
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="icon">
          <Trash />
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Delete Knowledge Group</DialogTitle>
          <DialogDescription>
            Delete the knowledge group from the shared knowledge.
          </DialogDescription>
        </DialogHeader>
        <Text>Are you sure you want to delete this knowledge group?</Text>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">Cancel</Button>
          </DialogClose>
          <Button variant="destructive" onClick={handleDelete}>
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
